import SentimentSatisfiedAltIcon from "@mui/icons-material/SentimentSatisfiedAltOutlined";

export const sentimentSatisfiedAlt = (props) => {
  return <SentimentSatisfiedAltIcon {...props} />;
};
